module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagex"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('a', {
    attrs: {
      "id": "map"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fxviii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionx"
  }, [_vm._v("Map of the Kovno area ("), _c('em', [_vm._v("above")]), _vm._v(") and detail of the Kovno ghetto ("), _c('em', [_vm._v("facing")]), _vm._v("), marking the locations of significant events mentioned in the text. The River Neris is locally known also as the Vilija River. "), _c('em', [_vm._v("Both maps courtesy of the United States Holocaust Memorial Museum")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c16829","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/map.vue
// module id = 78
// module chunks = 0